// extracted by mini-css-extract-plugin
module.exports = {"root":"GeolocationInfo_root__9XM-4","city":"GeolocationInfo_city__175gw","distance":"GeolocationInfo_distance__sNXWF","separator":"GeolocationInfo_separator__2AxNt"};